import { useState } from "react";
import { Button, Divider, Form, Input, Modal, Typography } from "antd";
import LoginIcon from "icons/LoginIcon";
import { Link } from "react-router-dom";
import { useLogin } from "services/auth";
import useAuthStore from "stores/auth";
import { useAsyncGetUserMe } from "services/user";
import { ILogin } from "types/auth";
const { Text } = Typography;

const useLoginModal = () => {
  const [isShowLogin, setIsShowLogin] = useState(false);
  const [form] = Form.useForm();

  const { setToken } = useAuthStore();
  const { mutateAsync } = useAsyncGetUserMe();
  const { loginAsync, isPending } = useLogin();
  const showLogin = () => setIsShowLogin(true);
  const hideLogin = () => setIsShowLogin(false);
  const [isLoginError, setIsLoginError] = useState<boolean>(false);

  const handleOnLogin = async (value: ILogin) => {
    try {
      const result = await loginAsync({
        email: value.email,
        password: value.password,
      });
      setToken(result.data.accessToken, result.data.refreshToken);
      await mutateAsync();
      hideLogin();
    } catch (e) {
      console.log("in error", e);
      setIsLoginError(true);
    }
  };

  const loginModal = (
    <Modal
      open={isShowLogin}
      centered
      onClose={hideLogin}
      onCancel={hideLogin}
      footer={false}
      confirmLoading={isPending}
      modalRender={(dom) => (
        <Form
          form={form}
          initialValues={{ modifier: "private" }}
          onFinish={handleOnLogin}
          onFinishFailed={() => console.log("onFinishFailed")}
        >
          {dom}
        </Form>
      )}
    >
      <div>
        <div className="flex justify-center">
          <img
            className="my-auto mr-4"
            src="/logo.png"
            width={69}
            height={69}
          />
          <div className="flex flex-col justify-center">
            <div className="font-semibold text-xl">นรินทร์เภสัช</div>
            <div className="text-xl">NARINONLINE</div>
          </div>
        </div>
        <Divider />
        <div className="flex flex-col gap-4 px-8">
          <div className="font-semibold">ยินดีต้อนรับเข้าสู่ระบบ</div>
          <Form.Item
            name="email"
            label=""
            rules={[
              {
                required: true,
                message: "กรุณากรอกอีเมล",
              },
              {
                type: "email",
                message: "กรุณากรอกอีเมลให้ถูกต้อง",
              },
            ]}
          >
            <Input placeholder="Email" size="large" />
          </Form.Item>
          <Form.Item
            name="password"
            label=""
            rules={[
              {
                required: true,
                message: "กรุณากรอกรหัสผ่าน",
              },
            ]}
          >
            <Input.Password placeholder="รหัสผ่าน" size="large" />
          </Form.Item>
          {/* <Link to={"/forgetpassword"}>
           <div className="text-end text-primary-700">ลืมรหัสผ่าน</div>
         </Link> */}
          <div className="text-center">
            <Button
              className="w-[200px]"
              size="large"
              type="primary"
              icon={<LoginIcon />}
              loading={isPending}
              htmlType="submit"
            >
              เข้าสู่ระบบ
            </Button>
          </div>
          {isLoginError && (
            <Text type="danger" className="text-center">
              อีเมล หรือ รหัสผ่านไม่ถูกต้อง
            </Text>
          )}
          <Link to={"/authen?tab=register"}>
            <div className="text-center text-primary-700">
              ยังไม่มีบัญชี ? <span className="font-semibold">สมัครสมาชิก</span>
            </div>
          </Link>
        </div>
      </div>
    </Modal>
  );
  return {
    isShowLogin,
    showLogin,
    hideLogin,
    loginModal,
  };
};

export default useLoginModal;
